<template>
    <div>
        <page-header :title="title" :items="items" />

        <div v-if="student.id" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <add-edit-form
                            v-model="student"
                            :edit-mode="editMode"
                            :server-errors="serverErrors"
                        />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div :class="{ 'mb-3': editMode }">
                            <button
                                class="btn btn-success btn-static waves-effect waves-light m-1"
                                @click="submitHandler"
                            >
                                <i class="fas fa-save" />
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import AddEditForm from '@/components/student-tags-list/AddEditForm';

export default {
    page: {
        title: 'Manage Student Tag'
    },

    components: {
        AddEditForm
    },

    data() {
        const { id = null, tagId = null } = this.$route.params;

        return {
            title: 'Edit student tag',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Student Tags List',
                    to: '/student-tags-list'
                },
                {
                    text: 'Edit',
                    active: true
                }
            ],
            id,
            tagId,
            editMode: !!id,
            student: {},
            serverErrors: [],
            selectedTag: {}
        };
    },

    async created() {
        try {
            const student = await this.getStudent(this.id);

            this.student = {
                ...student,
                tag: student.tags.find(tag => tag.id === this.tagId) || {}
            };
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getStudent: 'students/show',
            updateStudent: 'students/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            try {
                if (!this.student.tag?.id) {
                    this.$toasterError('Please select a tag to submit');

                    return;
                }

                const exist = !!~this.student.tags.findIndex(
                    tag => tag.id === this.student.tag.id
                );

                if (exist) {
                    this.$toasterError(
                        'This tag is already selected for a student. '
                    );

                    return;
                } else if (this.tagId) {
                    const index = this.student.tags.findIndex(
                        tag => tag.id === this.tagId
                    );

                    this.student.tags.splice(index, 1, this.student.tag);
                } else {
                    this.student.tags.push(this.student.tag);
                }

                const campuses = this.student.campuses.map(({ id }) => id);
                const tags = this.student.tags.map(({ id }) => id);
                const hugs = this.student.hugs.map(({ id }) => id);

                await this.updateStudent({
                    id: this.id,
                    data: {
                        ...this.student,
                        campuses,
                        tags,
                        hugs
                    }
                });

                this.$toaster('Student tag updated!');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
